import React, { useEffect } from 'react';
import { EnforceSSL } from './enforceSSL'

type ImageProps = {
    className?: string,
    imgUrl: string,
    defaultImg?: string,
    id?: string,
    title?: string,
    altText: string,
    width: number,
    height: number,
    useSSL?: boolean
}

export const ProductImage = ({ ...props }: ImageProps) => {
    const [img, setImg] = React.useState(props.useSSL ? EnforceSSL(props.imgUrl) : props.imgUrl);
    const [defaultImg, setDefaultImg] = React.useState(props.useSSL ? EnforceSSL(props.defaultImg) : props.defaultImg);

    useEffect(() => {
        if (props.useSSL) {
            setImg(EnforceSSL(props.imgUrl));
        } else {
            setImg(props.imgUrl);
        }

        if (props.useSSL && props.defaultImg) {
            setDefaultImg(EnforceSSL(props.defaultImg));
        } else {
            setDefaultImg(props.defaultImg)
        }
    }, [props.imgUrl, props.defaultImg, props.useSSL]);

    function checkImage(imgUrl: string, badImage: any) {
        var img = new Image()
        img.onerror = badImage;
        img.src = imgUrl
    }

    if (defaultImg && img !== defaultImg) {
        checkImage(img!, function () {
            if (defaultImg) {
                setImg(defaultImg);
            }
        });
    }

    return (
        <div className={props.className}>
            <img
                id={props.id}
                title={props.title}
                src={img}
                alt={props.altText}
                width={props.width}
                height={props.height}
            />
        </div>
    );
}

ProductImage.defaultProps = {
    useSSL: true
};